import {useMutation} from '@apollo/react-hooks'
import gql from 'graphql-tag'

import {PAYMENTS_ACCOUNTS_QUERY, WITHDRAWABLE_METHODS_QUERY} from '../../../../../../../graphql/queries'
import {SIGN_UPLOAD_URL_MUTATION} from '../../../../../../../graphql/mutations'
import {FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION} from '../../../hooks'


const CREATE_DEPOSIT_METHOD_ISSUE_VERIFICATION_MUTATION = gql`
  mutation(
    $accountId: Int!,
    $clientId: Int!,
    $paymentMethodOptionId: String!,
    $fileKey: String!,
    $cardNumber: String,
    $fileName: String!,
    $comment: String
  ) {
    createDepositMethodIssueVerification(
      accountId: $accountId,
      clientId: $clientId,
      paymentMethodOptionId: $paymentMethodOptionId,
      cardNumber: $cardNumber,
      fileKey: $fileKey,
      fileName: $fileName,
      comment: $comment
    ) {
      id
      accountId
      clientId
      paymentMethodOptionId
      fileUrl
      fileName
      processStatus
      comment
      meta
      internalRemark
      createdAt
      updatedAt
      __typename
    }
  }
`

function useCreateDepositMethodIssueVerification() {
  const [mutation, {loading}] = useMutation(CREATE_DEPOSIT_METHOD_ISSUE_VERIFICATION_MUTATION, {
    refetchQueries: [
      {query: PAYMENTS_ACCOUNTS_QUERY},
      {query: WITHDRAWABLE_METHODS_QUERY},
      {query: FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION},
    ]
  })
  const createDepositMethodIssueVerification = ({accountId, clientId, paymentMethodOptionId, fileKey, fileName, comment, cardNumber}) =>
    mutation({variables: {accountId, clientId, paymentMethodOptionId, fileKey, comment, fileName, cardNumber}})

  return {createDepositMethodIssueVerification, loading}
}

function useSignUploadUrl() {
  const [mutation] = useMutation(SIGN_UPLOAD_URL_MUTATION)

  const signUploadUrl = ({clientId}) => mutation({variables: {clientId}})

  return {signUploadUrl}
}

export {useCreateDepositMethodIssueVerification, useSignUploadUrl}
